import { render } from "./CollapseItem.vue?vue&type=template&id=10fa713a&scoped=true"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"

import "./CollapseItem.vue?vue&type=style&index=0&id=10fa713a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fa713a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
